import m from "mithril";

import IconWarning from "@app/icons/warning";

import s from "./styles.module.scss";
import { initMithrilComponent } from "@shared/utils/mithril";

interface IValidationErrorMessagingAttrs {
	errors: Record<string, string>;
	warnings?: Record<string, string>;
}
interface IValidationErrorMessagingState {}

export const ValidationErrorMessaging = initMithrilComponent<
	IValidationErrorMessagingAttrs,
	IValidationErrorMessagingState
>();

ValidationErrorMessaging.view = (vnode) => {
	const { errors } = vnode.attrs;

	return m("div", { class: s.error_section_container }, [
		m("section", { class: s.error_section }, [
			m("div", { class: s.warning_icon_container }, [
				m("p", { class: s.warning_icon_background_circle }, IconWarning),
			]),
			m(
				"ul",
				{ class: s.error_list },
				Object.entries(errors).map(([, v]) => m("li", { class: s.error_text }, v)),
			),
		]),
	]);
};
